
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.372 17.63c-.381 0-.653-.13-.817-.391-.163-.262-.158-.577.017-.948l4.312-9.555c.141-.315.31-.539.506-.67.207-.14.441-.212.702-.212.25 0 .474.071.67.213.207.13.381.354.523.67l4.328 9.554c.174.381.185.703.033.964-.153.25-.414.376-.784.376-.305 0-.545-.071-.719-.213-.163-.152-.31-.38-.441-.686l-.817-1.894h-5.618l-.8 1.894c-.142.316-.29.545-.442.686-.152.142-.37.213-.653.213zm4.688-9.375l-2.075 4.917h4.182l-2.075-4.917h-.032z","fill":"#000"}}),_c('rect',{attrs:{"x":"7","y":"19.5","width":"12","height":"2","rx":"1","fill":"#313131"}})])
          )
        }
      }
    